export function DisableFormAutofill(formId: string) {
  var inputs = document.querySelectorAll(`#${formId} input[type=text]`);
  inputs.forEach(input => {
    input.setAttribute('role', 'presentation');
    input.setAttribute('autocomplete', 'off');
  });
}
export function DisableFieldAutofill(id: string) {
  const input = document.getElementById(id);
  if (input) {
    input.setAttribute('role', 'presentation');
    input.setAttribute('autocomplete', 'off');
  }
}
export function Wait(func: () => any, time: number = 50) {
  setTimeout(() => {
    func();
  }, time);
}
